<template>
  <span class="str" :style="style">{{ data }}</span>
</template>

<script>
export default {
  name: 'NormalTextPart',
  props: {
    data: {
      type: String,
      default: '',
    },
    isBillText: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    style() {
      if (this.isBillText) {
        return {
          fontFamily: 'DiDiSans-Pro-Regular',
          fontSize: '18px',
          color: '#000',
        }
      }
      return {}
    },
  },
}
</script>

<style scoped lang="scss">
.str {
}
</style>
